import {
  AloftArea,
  expected,
  isDefined,
  orUndefined,
  schAlertType,
  schAloftArea,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';

export const bracketedGLA: AlertDefinition = ({ compSequence, propertyDataEntities }) => {
  const subjectGLA = orUndefined(schAloftArea.parse)(
    (propertyDataEntities.subject as SubjectPropertyDataState)?.subjectData.editableData
      .improvements.gla,
  );
  if (!subjectGLA) return undefined;

  const compGLAs = compSequence
    .map((id) =>
      orUndefined(schAloftArea.parse)(
        (propertyDataEntities[id] as CompPropertyDataState)?.compData.editableData.improvements.gla,
      ),
    )
    .filter(isDefined);

  if (compGLAs.length < 2) return undefined;

  const maxCompGLA = expected(AloftArea.max(compGLAs));
  const minCompGLA = expected(AloftArea.min(compGLAs));

  if (subjectGLA.le(maxCompGLA) && subjectGLA.ge(minCompGLA)) return undefined;

  return {
    type: schAlertType.enum.bracketedGLA,
    status: 'active',
    message: `The Subject's GLA (${subjectGLA.toString()}) is not bracketed (${minCompGLA.toString()} - ${maxCompGLA.toString()}).`,
    propertyID: 'subject',
    fixingInfo: {
      tips: "Tips: Expand your search parameters to locate sales that can bracket the Subject. This might mean going further back in time, expanding the search radius, or considering properties with other differences that can be reasonably adjusted. If the Subject's GLA cannot be bracketed, provide commentary on whether it is atypical for the market and any potential impact on marketability.",
      pairedCostRouteItem: schPairedCostRouteItem.enum.features,
    },
  };
};
